var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAffiliates = function SvgAffiliates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC5D",
    stroke: "#00CC5D",
    strokeWidth: 0.1,
    d: "M12 2.45a4.121 4.121 0 1 0 0 8.243 4.121 4.121 0 0 0 0-8.243Zm0 6.786a2.664 2.664 0 1 1 0-5.328 2.664 2.664 0 0 1 0 5.328Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M3.808 13.307v3.836h1.456v-3.736h13.472v3.788h1.457v-3.838c0-.777-.63-1.407-1.407-1.407H5.214c-.76 0-1.38.603-1.406 1.357Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.214 16.072a2.715 2.715 0 1 0 0 5.429 2.715 2.715 0 0 0 0-5.43m0 4.07a1.357 1.357 0 1 1 0-2.714 1.357 1.357 0 0 1 0 2.715M12 16.073a2.715 2.715 0 1 0 0 5.43 2.715 2.715 0 0 0 0-5.43m0 4.07a1.357 1.357 0 1 1 0-2.714 1.357 1.357 0 0 1 0 2.715m6.786-4.07a2.715 2.715 0 1 0 0 5.43 2.715 2.715 0 0 0 0-5.43m0 4.07a1.357 1.357 0 1 1 0-2.714 1.357 1.357 0 0 1 0 2.715"
  })));
};
export default SvgAffiliates;